import { logUsage } from 'owa-analytics-actions';
import getStore from '../store/store';
export var FAILED_OPTIONS_SEARCH_USAGE_KEY = 'OptionsFailedSearchTerm';
export default function logFailedSearchTerm(query) {
    // We don't want to bother logging an empty string as a failed search term,
    // nor if we're suppressing the datapoints (because the user is deleting a query
    // character by character)
    if (!!query && !getStore().suppressFailedSearchDatapoints) {
        logUsage(FAILED_OPTIONS_SEARCH_USAGE_KEY, { query: query });
    }
}
//# sourceMappingURL=logFailedSearchTerm.js.map